import axios from 'axios';

import IFollowUpAnalyticsPayload from '../../AnalyticsService/types/IFollowUpAnalyticsPayload';
import { ITaskSearchParam } from '../../TaskService';

const url = 'wsreporting/api/composable-analytics';

export const followupsCreatedMetrics = (searchFilter: Partial<ITaskSearchParam>) =>
  axios.post(`${url}/followups-metric-charts`, searchFilter);

export const followupsStatusStackedBarCharts = (searchFilter: Partial<ITaskSearchParam>) =>
  axios.post(`${url}/followups-source-stacked-bar-charts`, searchFilter);

export const followupsStatusRecruiterTables = (searchFilter: Partial<ITaskSearchParam>) =>
  axios.post(`${url}/followups-tables-source-recruiter`, searchFilter);

export const getFollowUpAnalyticsPostgres = (
  searchQuery: IFollowUpAnalyticsPayload,
  abortController: AbortController
) => axios.post(`taskapp/api/task/analytics`, searchQuery, abortController);
